// extracted by mini-css-extract-plugin
export var closeButton = "_s-1";
export var container = "_s-0";
export var fullModalImage = "_s-2";